import type { ReactElement } from "react";
import { MetricWidget } from "./MetricWidget";

/**
 * Retention (Day 7) % (ISSUE-352 AC3) — sourced from ISSUE-350's
 * activation/retention endpoint, still To Do as of 2026-09-03, so this
 * renders the shared not-yet-available placeholder until that endpoint ships.
 */
export function RetentionMetricWidget(): ReactElement {
  return (
    <MetricWidget
      title="Retention (Day 7)"
      unavailableReason="Sourced from ISSUE-350's activation/retention endpoint, which has not shipped yet."
    />
  );
}
